import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { X, RefreshCw } from 'lucide-react';
import { MORE_MENU } from '../lib/mock';

const colorClasses = {
  purple: 'bg-purple-50 text-purple',
  royal:  'bg-royal-50 text-royal',
  cyan:   'bg-cyan-50 text-cyan',
  mint:   'bg-mint-50 text-mint',
};

export default function MoreMenu({ open, onClose }) {
  const navigate = useNavigate();
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-navy/40 backdrop-blur-sm animate-fade-up" onClick={onClose}>
      <div className="absolute right-6 top-4 w-[380px] rounded-2xl bg-white p-5 shadow-pop" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <span className="inline-flex rounded-full bg-purple-50 px-3 py-1 text-[11px] font-bold tracking-wider text-purple">MORE</span>
          <button onClick={onClose} className="h-8 w-8 rounded-md hover:bg-canvas-100 inline-flex items-center justify-center"><X className="h-4 w-4" /></button>
        </div>
        <h3 className="mt-3 text-[22px] font-bold text-navy">Explore Gyan Dhara</h3>
        <p className="mt-1 text-[13px] text-ink-500">Shared pages available across every user profile.</p>
        <div className="mt-4 border-t border-canvas-200" />
        <ul className="mt-2 space-y-1">
          {MORE_MENU.map((m) => (
            <li key={m.title}>
              <Link to={m.to} onClick={onClose} className="flex items-start gap-3 rounded-xl p-3 hover:bg-canvas-100 transition-colors">
                <span className={`inline-flex h-9 w-9 items-center justify-center rounded-lg font-bold text-[13px] ${colorClasses[m.color]}`}>{m.letters}</span>
                <span className="flex-1">
                  <span className="block text-[14.5px] font-bold text-navy">{m.title}</span>
                  <span className="block text-[12.5px] text-ink-500">{m.desc}</span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
        <button
          onClick={() => { onClose(); navigate('/'); }}
          className="mt-3 flex w-full items-center justify-center gap-2 rounded-xl border border-purple-100 bg-canvas-100 px-4 py-3 text-[13.5px] font-semibold text-navy hover:bg-canvas-200 transition-colors"
        >
          <RefreshCw className="h-4 w-4 text-purple" /> Change user role
        </button>
      </div>
    </div>
  );
}
